import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';

import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import moment from "moment";

import {
    Button, ButtonGroup, Input, InputGroup, InputGroupText, Label,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Form, Badge, FormFeedback,
    Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Alert
} from "reactstrap";

import Select from 'react-select';

import FilesCustom, { FileUploadModal } from 'components/FilesCustom';

import Dropzone from 'react-dropzone';
import PdfViewer from 'components/PdfViewer';

import Img from 'components/Img';
import * as commonFunc from 'scripts/common';

import { withRouter } from 'components/withRouter';

class ManageFiles extends Component {
    static displayName = ManageFiles.name;

    static models;

    constructor(props) {
        super(props);

        this.customGen = React.createRef(null);

        this.state = { config: null, modelsList: null, files: null, entities : [] };
    }

    componentDidMount() {
        //console.debug("MOUNT");

        var context = this;

        if (this.props.updateUser) this.props.updateUser(function (curUser) {
            context.getContent();
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.searchParams !== prevProps.searchParams) {
            this.getContent();
        }
    }

    getContent() {
        this.setState({ config: null, modelsList: null });
        var context = this;

        commonFunc.getMethod("../api/site/GetSiteModels", { id: -1, categ: "FILES" }).then((responseModel) => {
            var dataModel = responseModel.data;
            if (dataModel.isSuccess && dataModel.result && dataModel.result.models) {
                //var customConfig = JSON.parse(dataModel.result);

                var filesConfig;
                var filteredModels = dataModel.result.models.filter((model) => model.extID === "FILES_CFG");
                if (filteredModels?.length) {
                    filesConfig = JSON.parse(filteredModels[0].value);
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: context.props.i18nManager.t("gal_fail"),
                        html: context.props.i18nManager.t("gal_failLoadModel")
                    });
                }
                var filesModels = {};
                dataModel.result.models.forEach((model) => {
                    filesModels[model.extID] = JSON.parse(model.value);
                });

                this.setState({ config: filesConfig, modelsList: filesModels });
            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadModel") + " :<br>" + dataModel.errorMessage
                });
            }
        });
    }

    render() {
        return this.state.config ? (
            <div>
                <FolderManager context={this} isShowingEntity={true} entity={"SITE"} defaultFileType={"GAL"} />
            </div>
        ) : <div>{this.props.i18nManager.t("gal_loadingModule")}</div>;
    }

}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}

export default withRouter(withI18n(ManageFiles));


function FolderManager(props) {
    var { context, entity, defaultFileType, isShowingEntity } = props;

    const [foldersState, setFoldersState] = React.useState([]);
    const [foldersTreeState, setFoldersTreeState] = React.useState({});

    const [selectedMode, setSelectedMode] = React.useState("tree");
    const [filesSorting, setFilesSorting] = React.useState("");

    const [selectedFolderEntity, setSelectedFolderEntity] = React.useState(null);
    const [selectedFolderSiteID, setSelectedFolderSiteID] = React.useState(null);
    const [selectedFolderPath, setSelectedFolderPath] = React.useState(null);
    const [selectedFileID, setSelectedFileID] = React.useState(null);

    const lastSearchReq = React.useRef(0);

    React.useEffect(() => {
        manageFiles(null, (newFiles) => {
            createTreeFolder(newFiles);
        });
    }, []);

    React.useEffect(() => {
        if (selectedFolderPath) manageFiles();
    }, [selectedFolderPath]);


    function manageFolder(foldersTree, folder, parentRootFolders) {
        var rootFolders = parentRootFolders;
        if (folder.depth === 2 && folder.name !== "Sites") {
            folder.children = null;
        }
        folder.children?.forEach(child => {
            if (child.depth >= 2) {
                commonFunc.setValue(foldersTree, child.fullPath, child);

                if (child.depth === 2) child.entityPath = child.name;
                else child.entityPath = folder.entityPath;

                if (!rootFolders) rootFolders = folder.children;
            }

            if (child.depth === 3) child.siteID = child.name;
            else child.siteID = folder.siteID || -1;


            if (child.children?.length) rootFolders = manageFolder(foldersTree, child, rootFolders);
        });
        return rootFolders;
    }

    function createTreeFolder(srcFiles) {
        var args = { searchPattern: "*" };
        args.entities = context.state.entities.length ? context.state.entities?.map(entity => { return { id: 0, value: entity.value, tag: "" }; }) : [{ id: 0, value: "*", tag: "" }];
        args.page = 1;
        args.maxPages = 1;
        args.maxItems = -1;
        args.prefix = "*";
        args.categ = "*";
        args.treeOnly = true;
        args.buildTree = true;

        commonFunc.postMethod("../api/data/SearchFiles", args).then((responseFolders) => {
            var dataFolders = responseFolders.data;
            if (dataFolders.isSuccess) {

                //TODO
                var foldersTree = {};
                var rootFolders = manageFolder(foldersTree, dataFolders.extraInfo.tree);
                setFoldersState(rootFolders);
                setFoldersTreeState(foldersTree);

            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadModel") + " :<br>" + dataFolders.errorMessage
                });
            }
        });

        return;

        //Création de l'arborescence
        var folders = [];
        var foldersTree = {};
        srcFiles?.forEach((file) => {
            var folder;
            var newFolder;

            //TEMP
            //if (file.categ === "AVA") file.prefix = "Test";

            var splittedFullPath = file.prefix.split("\\");
            var entityPath = splittedFullPath[1];

            var srcTag;
            var siteFolder;
            if (isShowingEntity) {
                if (!foldersTree[entityPath]) {
                    folder = { name: entityPath, siteID: -1, entityPath: entityPath, subFolders: [], count: 1 };
                    foldersTree[entityPath] = folder;
                    newFolder = true;
                }
                else {
                    folder = foldersTree[entityPath];
                    folder.count++;
                }

                srcTag = entityPath + (file.siteID?.toString() || "");

                var filteredSiteID = folder.subFolders.filter(subFolder => subFolder.siteID === file.siteID);
                if (!(filteredSiteID?.length)) {
                    siteFolder = { name: file.siteID, siteID: file.siteID, entityPath: entityPath, subFolders: [], count: 1 };
                    folder.subFolders.push(siteFolder);
                    commonFunc.setValue(foldersTree, srcTag, siteFolder);
                }
                else {
                    siteFolder = filteredSiteID[0];
                    siteFolder.count++;
                }
            }
            else {
                srcTag = (file.siteID?.toString() || "");
                var src = commonFunc.getValue(foldersTree, srcTag);
                if (!src) {
                    folder = { name: file.siteID, siteID: file.siteID, entityPath: entityPath, subFolders: [], count: 1 };
                    commonFunc.setValue(foldersTree, srcTag, folder);
                    newFolder = true;
                }
                else {
                    folder = src;
                    folder.count++;
                }
                siteFolder = folder;
            }
            console.debug(folder);


            //TEMP
            /*if (true) {
                var splittedPath = file.prefix.split("\\");*/

            if (!file.prefix.endsWith("\\Fichiers\\")) {
                var splittedPath = file.prefix.split("\\Fichiers\\");
                if (splittedPath[1]) {
                    splittedPath = splittedPath[1].split("\\");
                    var lastPath;
                    splittedPath.forEach((subPath) => {
                        if (!lastPath && !folder) {
                            lastPath = { name: subPath, siteID: file.siteID, entityPath: entityPath, subFolders: [], path: subPath, count: 1 };
                            folder = lastPath;
                            foldersTree[subPath] = folder;
                        }
                        else {
                            var fullPath = (lastPath ? (lastPath.path + "\\") : "") + subPath;
                            var treeVal = commonFunc.getValue(foldersTree, srcTag + fullPath);
                            if (treeVal) {
                                lastPath = treeVal;
                                lastPath.count++;
                            }
                            else {
                                if (lastPath) {
                                    var newLastPath = { name: subPath, siteID: file.siteID, entityPath: entityPath, path: fullPath, count: 1 };
                                    if (!lastPath.subFolders) lastPath.subFolders = [];
                                    lastPath.subFolders.push(newLastPath);
                                    lastPath = newLastPath;
                                    commonFunc.setValue(foldersTree, srcTag + fullPath, lastPath);
                                }
                                else {
                                    lastPath = { name: subPath, siteID: file.siteID, entityPath: entityPath, path: subPath, count: 1 };
                                    siteFolder.subFolders.push(lastPath);
                                    commonFunc.setValue(foldersTree, srcTag + subPath, lastPath);
                                }
                            }
                        }
                    });
                }
            }
            if (newFolder) folders.push(folder);
        });
        setFoldersState(folders);
        setFoldersTreeState(foldersTree);
    }

    function manageFiles(searchValue, callback) {
        if (searchValue || searchValue === "") context.setState({ searchValue: searchValue });
        else searchValue = context.state.searchValue;

        Swal.fire({
            title: context.props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        //TODO
        var entityG = "SITE";

        var maxItems = ((commonFunc.isBlank(searchValue) && !selectedFolderPath) ? 10 : 1000);//5000 TODO

        var args = { searchPattern: searchValue };
        args.entities = context.state.entities.length ? context.state.entities?.map(entity => { return { id: 0, value: entity.value, tag: "" }; }) : [{ id: 0, value: "*", tag: "" }];
        args.page = 1;
        args.maxItems = maxItems;
        args.prefix = selectedFolderPath || "*";
        args.categ = "*";
        args.treeOnly = false;
        args.buildTree = false;

        //treeOnly >> DIR
        //buildTree >> DIR+Files

        //postMethod("../api/data/SearchFiles", {searchPattern:'141_cotedroit_etatlieux.jpg', Prefix:'*',  Page:1, MaxItems:5000, categ:'*', treeOnly:true, buildTree:true, Entities:[]});
        commonFunc.postMethod("../api/data/SearchFiles", args).then((responseFiles) => {
        //commonFunc.getMethod("../api/" + entityG + "/Get" + entityG + "Files", { bindID: 1, fileId: -1 }).then((responseModel) => {
            Swal.close();
            var dataFiles = responseFiles.data;
            if (dataFiles.isSuccess && dataFiles.result) {

                dataFiles.result.forEach(file => { file.length = file.size; })

                context.setState({ files: dataFiles.result });
                if (callback && typeof (callback) === "function") { callback(dataFiles.result); }
            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: dataFiles.errorMessage
                });
            }
        });
    }

    function selectFile(file) {
        Swal.fire({
            title: context.props.i18nManager.t("gal_loading"),
            didOpen: () => { Swal.showLoading() },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
        });

        var args = { searchPattern: "*" };
        args.entities = [];
        args.page = 1;
        args.maxPages = 1;
        args.maxItems = 1;
        args.prefix = "*";
        args.categ = "*";
        args.treeOnly = false;
        args.buildTree = false;
        args.generateLink = true;
        args.fileId = file.idFile;
        commonFunc.postMethod("../api/data/SearchFiles", args).then((responseFile) => {
            Swal.close();
            var dataFile = responseFile.data;
            if (dataFile.isSuccess && dataFile.result?.length) {

                file.absoluteUri = dataFile.result[0].absoluteUri;

            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: dataFile.errorMessage
                });
            }

            setSelectedFileID(file.idFile);
        });
    }

    function addFolder(dataFolder) {
        Swal.fire({
            title: "Saisissez le nom du dossier",
            text: dataFolder ? ("Sera créé dans le dossier " + dataFolder.name) : "",
            input: "text",
            inputPlaceholder: "Nom du dossier",
            showCancelButton: true,
            confirmButtonText: "Créer",
            cancelButtonText: "Annuler",
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#dc3545",
            customClass: {
                popup: "p-3"
            },
            preConfirm: (text) => {
                if (!text) {
                    Swal.showValidationMessage("Veuillez saisir un nom");
                }
            }
        }).then((result) => {
            if (result.value) {
                //TODO
                var mode = "";
                var entityPath = dataFolder?.entityPath || "";
                var bindID = dataFolder?.siteID || -1;
                var manageParents = false;
                if (mode === "commonSites") {
                    bindID = -1;
                }
                else if (mode === "commonParent") {
                    bindID = -1;
                    manageParents = true;
                }

                commonFunc.postMethod("../api/data/CreateFolder", { name: result.value, bindID: bindID, manageParents: manageParents, entity: entityPath/*entity*/ }).then((response) => {
                    if (response.data && response.data.isSuccess) {

                        manageFiles();

                        /*if (dataFolder) {
                            dataFolder.subFolders.push();
                        }
                        else {
                            folders.push();
                        }*/

                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: "Echec de l'ajout de dossier<br/>" + response.data.errorMessage
                        });
                    }
                });
            }
        });
    }

    function searchFiles(e) {
        if (e.target?.value.length >= 4 || context.state.searchValue?.length) {
            var idRq = parseInt(Math.floor(Date.now() + Math.random() * 1000000000000001).toString().substring(6));
            lastSearchReq.current = idRq;
            setTimeout(() => {
                if (lastSearchReq.current === idRq) {
                    var newValue = e.target?.value.length >= 4 ? e.target?.value : "";
                    manageFiles(newValue);
                }
            }, 1000);
        }
    }

    //Gestion SelectedFile
    var selectedFile;
    var filteredSFile = context.state.files?.filter(file => file.idFile === selectedFileID);
    if (filteredSFile?.length) selectedFile = filteredSFile[0];

    var selectedFolder = commonFunc.getValue(foldersTreeState, (selectedFolderPath || ""));

    var filePath
    if (selectedFile) {
        const file = {
            fileId: selectedFile.idFile,
            fileName: selectedFile.name,
            container: selectedFile.rootContainer,
            etag: selectedFile.etag,
            accessToken: selectedFile.absoluteUri,
            newWindow: false
        };
        filePath = "/api/data/DownloadFileByUri?" + commonFunc.toParams(file);
        if (selectedFile.instanceFile) filePath = selectedFile.instanceFile.preview;
    }
    var fileIcon = selectedFile ? commonFunc.getFilesFaIcon(selectedFile.name, selectedFile.categ) : null;
    var isPicture = fileIcon?.props["data-typef"] === "img";
    var isPDF = selectedFile?.contentType === "application/pdf";



    var sortedFiles = context.state.files?.length ? [...context.state.files] : [];
    switch (filesSorting) {
        case "length":
            sortedFiles = sortedFiles.sort((a, b) => b.length - a.length);
            break;
        case "lengthInverse":
            sortedFiles = sortedFiles.sort((a, b) => a.length - b.length);
            break;
        case "dSysMod":
            sortedFiles = sortedFiles.sort((a, b) => { return new Date(b.dSysMod).getTime() - new Date(a.dSysMod).getTime(); });
            break;
        case "dSysModInverse":
            sortedFiles = sortedFiles.sort((a, b) => { return new Date(a.dSysMod).getTime() - new Date(b.dSysMod).getTime(); });
            break;
        case "name":
            sortedFiles = sortedFiles.sort((a, b) => a.name.localeCompare(b.name));
            break;
        case "nameInverse":
            sortedFiles = sortedFiles.sort((a, b) => b.name.localeCompare(a.name));
            break;
        default: break;
    }

    var entities = [{ value: "SITE", "label": "Agence" }, { value: "REPORT", "label": "Rapports" }, { value: "CLIENT", "label": "Clients" }, { value: "EMPLOYEE", "label": "Collaborateurs" }, { value: "MATERIAL", "label": "Matériels" },
        { value: "SHOPORDER", "label": "Devis" }, { value: "LEAD", "label": "Leads" }, { value: "TICKET", "label": "Tickets" }, { value: "CUSTOM", "label": "Custom" }];

    var sorting = [{ value: "", label: "Aucun" }, { value: "length", label: "Taille ↓" }, { value: "lengthInverse", label: "Taille ↑" }, { value: "dSysMod", label: "Date ↓" }, { value: "dSysModInverse", label: "Date ↑" }, { value: "name", label: "Nom ↓" }, { value: "nameInverse", label: "Nom ↑" }];

    return <div className="filespace-mfiles">
        <Row className="mb-2">
            <Col className="col-auto me-3 pe-0 align-content-center" style={{ minWidth: "180px" }}>
                <ButtonGroup className="me-2">
                    <Button className={`btn-sm btn-simple ${selectedMode === "list" ? "active" : ""}`} color="dark" onClick={() => { setSelectedMode("list"); setSelectedFileID(null); }}><i className="fa fa-list"></i> Liste</Button>
                    <Button className={`btn-sm btn-simple ${selectedMode === "tree" ? "active" : ""}`} color="dark" onClick={() => { setSelectedMode("tree"); setSelectedFileID(null); }}><i className="fa fa-folder"></i> Arborescence</Button>
                    <Button className={`btn-sm btn-simple d-none ${selectedMode === "grid" ? "active" : ""}`} color="dark" onClick={() => { setSelectedMode("grid"); setSelectedFileID(null); }}><i className="fa fa-border-all"></i> Grille</Button>
                </ButtonGroup>
            </Col>
            <Col className="align-content-center">

                TODO STATUS ???
            </Col>
            <Col className="col-12 col-sm-auto align-items-end text-end d-flex">
                <div>
                    <Label>Trié par</Label>
                    <Select isMulti={false} className={``} defaultValue={filesSorting} onChange={(e, target) => {
                        setFilesSorting(e.value);
                    }} value={{ value: filesSorting, label: sorting.filter(item => item.value === filesSorting)[0].label }} options={sorting} />
                </div>
                <div>
                    <Label>Modules</Label>
                    <Select isMulti={true} className={``} placeholder="Tous" onChange={(e, target) => {
                        var list = context.state.entities;
                        if (target.action === "remove-value") {
                            list = list.filter(entity => entity.value !== target.removedValue.value);
                            context.setState({ entities: list });
                        }
                        else if (target.action === "select-option") {
                            list.push(target.option);
                            context.setState({ entities: list });
                        }
                        else if (target.action === "clear") {
                            context.setState({ entities: [] });
                        }
                    }} options={entities} />
                </div>
                <div className="text-secondary" style={{ fontSize: "12px" }}>TODO</div>
            </Col>
        </Row>

        <Row>
            <Col xs="12" sm="4" md="3" xl="2">
                <Card className="m-0 user-select-none" style={{ height: "80vh" }}>
                    <CardHeader className="d-flex align-items-center text-dark p-3 py-2" data-background-color="true">
                        <i className="fa fa-folder me-2"></i> <b style={{ flex: "auto" }}>Explorateur</b> <Button className="btn-light btn-icon text-dark m-0" onClick={() => { addFolder(); }}><i className="fa fa-plus"></i></Button>
                    </CardHeader>
                    <CardBody>
                        {foldersState.map((folder, index) => {
                            return <Folder key={"folder" + index + folder.name} data={folder} selectedFolderPath={selectedFolderPath} selectedFolderSiteID={selectedFolderSiteID} selectedFolderEntity={selectedFolderEntity}
                                setSelectedFolder={(data) => {
                                    setSelectedFolderPath(data.fullPath);
                                    setSelectedFolderSiteID(parseInt(data.siteID) > 0 ? data.siteID : null);
                                    setSelectedFolderEntity(data.entityPath);
                                }} addFolder={addFolder} />
                        })}
                    </CardBody>
                </Card>
            </Col>

            <Col xs="12" sm="4" md="5" xl="6">
                <Card className="m-0 user-select-none" style={{ height: "80vh" }}>
                    <CardHeader className="d-flex align-items-center py-2">
                        <div style={{ flex: "auto" }}>
                            <b>{selectedFolder?.name} &bull; {selectedFolderPath} &bull; {selectedFolder?.size > 0 ? commonFunc.bytesToSize(selectedFolder?.size, 1) : ""}</b>
                            <Button className="btn-light btn-icon text-dark m-0" onClick={() => { addFolder(selectedFolder); }}><i className="fa fa-plus"></i></Button>
                        </div>
                        <div>
                            <InputGroup className="">
                                <InputGroupText>
                                    <i aria-hidden="true" className="fa fa-magnifying-glass"></i>
                                </InputGroupText>
                                <Input type="search" autoComplete="off" aria-autocomplete="none" name="mfile-search" id="mfilesearch" placeholder="Recherche" onInput={(e) => searchFiles(e)} />
                            </InputGroup>
                        </div>
                    </CardHeader>
                    <CardBody>
                        {sortedFiles?.length ? <FileSpace {...props} files={sortedFiles} selectedFolderEntity={selectedFolderEntity} selectedFolderSiteID={selectedFolderSiteID} selectedFolderPath={selectedFolderPath}
                            selectedMode={selectedMode} selectFile={selectFile} manageFiles={manageFiles} /> : ""}
                    </CardBody>
                </Card>
            </Col>


            {selectedFile ? <Col xs="4">
                <Card className="m-0" style={{ height: "80vh" }}>
                    <CardHeader className="p-3 text-dark" data-background-color="true">
                        <i className="fa fa-circle-info me-2"></i> <b>Détails</b>
                    </CardHeader>
                    <CardBody>
                        <div className="text-secondary fw-bold" style={{ fontSize: "12px" }}>{("Informations").toUpperCase()}</div>
                        <div className="flex_between">
                            <div className="text-secondary">Nom</div>
                            <div className="text-dark">{selectedFile.name}</div>
                        </div>
                        <div className="flex_between">
                            <div className="text-secondary">Taille</div>
                            <div className="text-dark">{commonFunc.bytesToSize(selectedFile.length, 1)}</div>
                        </div>
                        <div className="flex_between">
                            <div className="text-secondary">Créer par</div>
                            <div className="text-dark">{selectedFile.tenantUser?.value}</div>
                        </div>
                        <div className="flex_between">
                            <div className="text-secondary">Date création</div>
                            <div className="text-dark">{selectedFile.dSysMod ? (commonFunc.formatDateTime(selectedFile.dSysMod instanceof Date ? selectedFile.dSysMod : moment(commonFunc.restStringToDate(selectedFile.dSysMod)).utc(true).toDate())) : "."}</div>
                        </div>
                        <div className="flex_between">
                            <div className="text-secondary">Catégorie</div>
                            <div className="text-dark">{selectedFile.fileType?.value + " (" + selectedFile.categ + ")"}</div>
                        </div>

                        {(isPicture || isPDF) ? <>
                            <div className="hr-line-dashed" />

                            <div className="text-secondary fw-bold" style={{ fontSize: "12px" }}>{("Aperçu").toUpperCase()}</div>
                            {isPicture ? <div className="text-center"><Img style={{ width: "100%", maxWidth: "450px" }} className='img-responsive' src={selectedFile.instanceFile ? selectedFile.instanceFile.preview : filePath} alt='' /></div> : ""}
                            {isPDF ? <PdfViewer url={filePath} containerId="embdActFinalPDf" shouldRender={true} pagemode={"none"} zoom={"page-width"} style={{ minHeight: "50vh" }}></PdfViewer> : ""}
                        </> : ""}
                    </CardBody>
                </Card>

                <Card className="m-0 d-none">
                    <CardHeader className="p-3 text-dark" data-background-color="true">
                        <i className="fa fa-history me-2"></i> <b>Activité</b>
                    </CardHeader>
                    <CardBody>
                        TODO
                    </CardBody>
                </Card>
            </Col> : ""}
        </Row>
    </div>;
}

function FileSpace(props) {
    var { context, entity, defaultFileType, files, selectedMode, selectedFolderEntity, selectedFolderSiteID, selectedFolderPath, selectFile, manageFiles } = props;

    var filesType = [];

    const [fileType, setFileType] = React.useState(defaultFileType || "");
    const [fileTypeId, setFileTypeId] = React.useState((filesType && defaultFileType) ? () => {
        var typesFiltered = filesType.filter(type => type.refExtID === defaultFileType);
        if (typesFiltered.length) {
            return typesFiltered[0].idFileType || 0;
        }
        else {
            return 0;
        }
    } : 0);


    var filesAltObj = {};
    if (context.filesType) filesAltObj.filesType = context.filesType;
    else filesAltObj.altFilesTypes = "../api/" + entity + "/Get" + entity + "FilesType";

    //filesAltObj.files = files/*?.map(file => file.file.categ !== "RCP" ? file.file : null).filter(file => file !== null)*/ || [];
    filesAltObj.files = files/*?.filter(file => {
        var splittedFullPath = file.prefix.split("\\");
        return (!selectedFolderEntity || splittedFullPath[1] === selectedFolderEntity) && (!selectedFolderSiteID || file.siteID === selectedFolderSiteID) && (!selectedFolderPath || file.prefix.indexOf(selectedFolderPath) >= 0);
    })*/;

    filesAltObj.setFiles = (cptFiles) => { console.debug("refresh"); manageFiles(); };

    var uploadTypes = props.accept || props.parentProps?.accept || {};

    var isSiteContext = selectedFolderEntity === "Sites" && parseInt(selectedFolderSiteID) > 0;

    return <div className=" text-start">
        {isSiteContext ? <Dropzone accept={uploadTypes}
            maxFiles={props.parentProps?.maxFiles || 0}
            //maxSize={props.parentProps.maxSize || 14990000}//Infinity
            noClick
            noKeyboard
            noDragEventsBubbling
            preventDropOnDocument={false}
            onDrop={(acceptedFiles, fileRejections, e) => {
                if (e) e.target.classList.remove("hover");

                acceptedFiles.forEach((file) => {
                    const reader = new FileReader()

                    reader.onabort = () => console.log('file reading was aborted')
                    reader.onerror = () => console.log('file reading has failed')
                    reader.onload = () => {
                        // Do whatever you want with the file contents
                        const binaryStr = reader.result
                        console.log(binaryStr)
                    }
                    reader.readAsArrayBuffer(file)
                });

                if (fileRejections && fileRejections.length) {
                    Swal.fire({
                        icon: "warning",
                        title: "Attention",
                        html: "Certains fichiers ne peuvent pas être uploadé :<br/>" + fileRejections.map(file => "<div title='" + file.errors.map(error => error.message.replace("Too many files", "Trop de fichiers").replace("File is larger than", "Fichiers trop volumineux : ").replace("bytes", "octets max") + "\n") + "'>" + file.file.name + "<i class='fa fa-2xs fa-circle-info'></i></div>")
                    });
                }

                var newFiles = acceptedFiles.map(file => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    docType: file.docType || fileType,
                    docTypeId: file.docTypeId || fileTypeId,
                }));
                if (!props.parentProps?.maxFiles || ((newFiles?.length || 0) <= props.parentProps?.maxFiles)) {
                    //newFiles = newFiles.concat(localFiles);
                    //setLocalFiles(newFiles);
                    //setRerender(!rerender);



                    var modalRoot;

                    //Traitement des informations retourné par le Dialog
                    var callbackModal = function (modalFiles) {
                        console.debug(modalFiles);

                        //setFiles(modalFiles);

                        /*if (globalProps.files) {
                            var newFiles = globalProps.files;
                            modalFiles.forEach(file => {
                                console.debug(file);
                                var tempID = parseInt(Math.floor(Date.now() + Math.random() * 1000000000000001).toString().substring(6));
                                if (globalProps.noUploads) newFiles.push({ idFile: tempID, name: file.name, instanceFile: file, dSysMod: file.lastModifiedDate, prefix: file.docType, length: file.size, categ: file.docType });
                                else if (file.responseData) newFiles.push(file.responseData.result);
                            });
                            if (globalProps.setFiles) globalProps.setFiles(newFiles);
                        }
                        if (globalProps.resetAfterUpload) globalProps.files.length = 0;
                        else loadFiles();*/

                        manageFiles();

                        modalRoot.unmount();
                    };

                    modalRoot = createRoot(document.createElement('div'));
                    /*modalRoot.render(<FileUploadModal parentProps={globalProps} title={globalProps.customTitle || ("Transfert de Fichiers " + (globalProps.srcName || ""))} defaultFileType={globalProps.defaultFileType} fileTypeID={globalProps.fileTypeID} bindID={globalProps.bindID}
                        waitForCompletion={globalProps.waitForCompletion} files={newFiles} callback={callbackModal}></FileUploadModal>);*/

                    modalRoot.render(<FileUploadModal files={newFiles} parentProps={{
                        uploadAutoClose: true, noChooseTypes: false, noUploads: false, /*accept: { "application/pdf": [".pdf"] },*/
                        altFilesTypes: "../api/" + entity + "/Get" + entity + "FilesType", altUploadFilesUrl: "../api/" + entity + "/Upload" + entity + "Files"
                    }} title={"Upload Fichiers"} defaultFileType={fileType} fileTypeID={entity} bindID={selectedFolderSiteID} callback={callbackModal}></FileUploadModal>);


                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Echec",
                        html: "Nombre de fichiers maximum dépassé"
                    });
                }
            }}
            onDragEnter={(e) => {
                e.target.classList.add("hover");
            }}
            onDragLeave={(e) => {
                e.target.classList.remove("hover");
            }}
        >
            {({ acceptedFiles, getRootProps, getInputProps, open, rootRef, inputRef, isFocused }) => {

                return (
                    <section>
                        <div {...getRootProps()}>
                            <input {...getInputProps()} />
                            <div className="thumbsContainer m-0" style={{ height: "275px" }}>

                            </div>
                        </div>
                    </section>
                );
            }}
        </Dropzone> : ""}


        <Row className={`mt-2 ${isSiteContext ? "" : "noDrop"}`}>
            <Col xs="12">
                <div className="text-secondary fw-bold" style={{ fontSize: "12px" }}>{("Documents").toUpperCase()}</div>
                <FilesCustom className={`mf-files`} bindID={selectedFolderSiteID || -1} rightType={entity + "_FILES"} checkRights={context.props.checkRights} fileTypeID={entity} src={null} onFileClick={(file, node) => { selectFile(file) }}
                    srcName={selectedFolderPath} shouldRender noPreview noUploadBtn={!isSiteContext} altRendering={selectedMode === "list"} listRendering={selectedMode === "tree"} defaultFileType={fileType} checkProps {...filesAltObj/*TODO : SEND PATH UPLOAD*/}
                    altFilesUrl={"../api/" + entity + "/Get" + entity + "Files"} altRemoveFilesUrl={"../api/" + entity + "/Remove" + entity + "File"} altUploadFilesUrl={"../api/" + entity + "/Upload" + entity + "Files"} />
            </Col>
        </Row>
    </div>;
}

function Folder(props) {
    var { data, selectedFolderEntity, selectedFolderSiteID, selectedFolderPath } = props;

    const [collapsed, setCollapsed] = React.useState(true);


    var hasSubs = data.children?.length;
    var selected = selectedFolderEntity === data.entityPath && ((data.siteID === -1 && !selectedFolderSiteID) || selectedFolderSiteID === data.siteID) && selectedFolderPath === data.fullPath;

    return <div className="ms-2">
        <div className={`d-flex cursor-pointer align-items-center px-1`} style={selected ? { backgroundColor: "#AAAAAA66", borderRadius: "5px" } : {}} onClick={() => {
            if (hasSubs) setCollapsed(false);
            props.setSelectedFolder(data);
        }}>
            {hasSubs ? <span onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setCollapsed(!collapsed);
                props.setSelectedFolder(data);
            }}>{(collapsed ? <i className="fa fa-chevron-right me-2 mt-1" style={{ width: "10px" }}></i> : <i className="fa fa-chevron-down me-2 mt-1" style={{ width: "10px" }}></i>)}</span> : ""}
            <i className="far fa-folder text-warning me-1"></i> <span style={{ flex: "auto" }}>{data.name}</span>
            <Badge className="float-end text-dark" color="light">{data.fileCount}</Badge>
            <Button className="btn-light btn-round text-dark m-0 ms-1 p-0 d-none" onClick={() => { props.addFolder(data); }} style={{ width: "15px", height: "15px" }}><i className="fa fa-plus m-0"></i></Button>
        </div>
        
        {!collapsed ? <>
            {data.children.map((subFolder, index) => <Folder {...props} key={"subFolder" + data.name + index + subFolder.name} data={subFolder} />)}
        </> : ""}
    </div>;
}